sap.ui.requireSync("jquery.sap.properties");
